import { isEmpty } from 'lodash';

import {
    ADD_INTERESTS_TARGETING_SET,
    CLOSE_INTERESTS_TARGETING_EDITOR,
    INTERESTS_TARGETING_CHANGE_ITEM,
    INTERESTS_TARGETING_CHANGE_SET_PERIOD,
    InterestsTargetingEditorAction,
    OPEN_INTERESTS_TARGETING_EDITOR,
    REMOVE_INTERESTS_TARGETING_SET,
    SELECT_ITEM_INTERESTS_EDITOR
} from '../../actions/targetings/interestsEditor';
import { InterestsSetType } from '../../components/InterestsSetEditor/InterestsSetEditor';
import { InterestsTargetingEditorState } from '../../typings/audienceTargetings';
import { CryptaInterestTypeWeb } from '../../typings/graphql-grid';
import { InterestsEditorsState, State } from '../../typings/state';

export const defaultInterestsTargetingSetState: InterestsSetType = {
    period: CryptaInterestTypeWeb.all,
    checkedList: [],
    openedList: []
};

export const defaultInterestsTargetingEditorsState: InterestsTargetingEditorState = {
    isOpen: false,
    value: [defaultInterestsTargetingSetState]
};

function updateList(list: string[], id: string): string[] {
    return list.includes(id)
        ? list.filter((listItemId: string) => listItemId !== id)
        : [...list, id];
}

export function interestsTargetingEditor(
    state: InterestsEditorsState = {},
    action: InterestsTargetingEditorAction,
    fullState: State
): InterestsEditorsState {
    switch (action.type) {
        case OPEN_INTERESTS_TARGETING_EDITOR: {
            const editor = state[action.id] || {
                ...defaultInterestsTargetingEditorsState
            };

            if (!isEmpty(action.value)) {
                editor.value = action.value;
            }

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    isOpen: true
                }
            };
        }

        case INTERESTS_TARGETING_CHANGE_ITEM: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    value: editor.value.map(
                        (set: InterestsSetType, index: number) => {
                            const { checkedList } = set;

                            if (index === action.setIndex) {
                                return {
                                    ...set,
                                    checkedList: updateList(
                                        checkedList,
                                        action.itemId
                                    )
                                };
                            } else {
                                return set;
                            }
                        }
                    )
                }
            };
        }

        case SELECT_ITEM_INTERESTS_EDITOR: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    value: editor.value.map(
                        (set: InterestsSetType, index: number) => {
                            const { openedList } = set;

                            if (index === action.setIndex) {
                                return {
                                    ...set,
                                    openedList: updateList(
                                        openedList,
                                        action.itemId
                                    )
                                };
                            } else {
                                return set;
                            }
                        }
                    )
                }
            };
        }

        case ADD_INTERESTS_TARGETING_SET: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    value: [
                        ...editor.value,
                        { ...defaultInterestsTargetingSetState }
                    ]
                }
            };
        }

        case INTERESTS_TARGETING_CHANGE_SET_PERIOD: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    value: editor.value.map(
                        (set: InterestsSetType, index: number) => {
                            return index === action.setIndex
                                ? { ...set, period: action.value }
                                : set;
                        }
                    )
                }
            };
        }

        case REMOVE_INTERESTS_TARGETING_SET: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    value: editor.value.filter(
                        (set: InterestsSetType, index: number) =>
                            index !== action.setIndex
                    )
                }
            };
        }

        case CLOSE_INTERESTS_TARGETING_EDITOR: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    value: action.value || editor.value,
                    isOpen: false
                }
            };
        }

        default:
            return state;
    }
}
